import { BaseErrorModel } from "@/models/core.model";
import React from "react";
import { Message } from "rsuite";

interface ErrorMessageProps {
  model?: BaseErrorModel,
  style?: React.CSSProperties,
  header?: React.ReactNode
}
const ErrorMessage : React.FC<ErrorMessageProps> = ({ model, style, header }) => {
    const errors = model?.errors ?? [];
    const errorMessage = model?.errorMessage ?? "An unexpected error occurred.";
    const fieldErrors: string[] = [];
    for (const field in errors) {
      if (errors.hasOwnProperty(field)) {
        // Loop through the array of error messages for each field
        errors[field].forEach(error => {
           fieldErrors.push(`${field}: ${error}`);
        });
      }
    }
    return (
      <Message style={style} showIcon type="error" header={header} >
        <p>
          <strong>{errorMessage}</strong>
        </p>
        {fieldErrors.length > 0 && <ol>
        {fieldErrors.map((err, index) => (
          <li key={index}>{err}</li>
        ))}
        </ol>}
      </Message>
    );
  };

  export default ErrorMessage;